import { GROWTH_WORKFLOWS } from './growthConstants';

export const REACT_CONFIG: any = {
	[GROWTH_WORKFLOWS.ON24]: {
		appContainerClass: 'on24',
		utilNav: {
			showJarvis: false,
			children: ['help', 'navIcon'],
		},
	},
	[GROWTH_WORKFLOWS.THROUGHLINE]: {
		appContainerClass: 'throughline',
		navbar: {
			navbarClass: 'growthThroughlineDarkTheme',
		},
		utilNav: {
			showJarvis: false,
			utilNavClass: 'growthThroughlineDarkNavTheme',
			children: ['navIcon'],
		},
	},
	[GROWTH_WORKFLOWS.TODOLIST]: {
		appContainerClass: 'todolist',
	},
	[GROWTH_WORKFLOWS.CCT_TODOLIST]: {
		appContainerClass: 'cct-todolist',
		utilNav: {
			showJarvis: false,
		},
	},
};
